import { defineComponent as _defineComponent } from 'vue'
import { computed, useRoute, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useTranslate } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { getProductSetsStore } from "@/store/product-sets";
import { getProfilesStore } from "@/store/profiles";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSetTile',
  props: {
  productSetId: {
    type: String,
    required: true,
  },
  width: {
    type: String || Number,
    required: false,
    default: "",
  },
  experiment: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const { t } = useTranslate();
const store = useStore();
const route = useRoute();
const amplitude = useAmplitude();



const productSet = computed(() => {
  return getProductSetsStore(store).productSets[props.productSetId];
});

const subtype = computed(() => {
  return productSet.value?.subtype;
});

const displayName = computed(() => {
  const profileId = productSet.value?.profileId;
  return profileId ? getProfilesStore(store)?.profiles[profileId]?.displayName || "" : undefined;
});

const subtitle = computed(() => {
  const count = getProductSetsStore(store).productSets[props.productSetId]?.productCount;

  return count ? t("{count} Products", { count: count?.toString() ?? "" }).value : "";
});

const setReferringComponent = () => {
  let section;

  if (route.value.name === "explore-displayName") {
    section = "product sets carousel";
  }

  getAmplitudeStore(store).setReferringComponent(
    amplitude?.getReferringComponentByPage(route.value.name ?? "", section) ?? "",
  );
};

return { __sfc: true,t, store, route, amplitude, props, productSet, subtype, displayName, subtitle, setReferringComponent }
}

})